/* Hover artwork is optional: request it only when a mouse or keyboard user explores a card.
   Templates stay inert on touch, and a failed image never covers the primary artwork. */
(() => {
  const loadDetail = target => {
    const template = target.closest('.card')?.querySelector('template[data-card-detail]');
    if (!template) return;
    const image = template.content.querySelector('img')?.cloneNode(true);
    if (!image) return;
    image.addEventListener('load', () => { image.dataset.detailReady = ''; }, { once: true });
    image.addEventListener('error', () => { image.remove(); }, { once: true });
    template.replaceWith(image);
    if (image.complete && image.naturalWidth) image.dataset.detailReady = '';
  };
  // Delegation also covers filters, search and theme-editor section replacements.
  document.addEventListener('pointerover', event => {
    if (event.pointerType === 'mouse') loadDetail(event.target);
  });
  document.addEventListener('focusin', event => {
    if (event.target.matches(':focus-visible')) loadDetail(event.target);
  });
})();
